"use strict";
function identity(value) {
    return value;
}
module.exports = identity;
//# sourceMappingURL=identity.js.map